export const convertNumberToCurrency = (number, locale) => {
  return new Intl.NumberFormat(locale).format(number);
};
